<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="orgons"
      :search="filterSearch"
      :loading="loading"
      :page="page"
      :options.sync="options"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.orgons_tissues.description')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.name"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.hospitais`]="{ item }">
        <div class="d-flex flex-wrap align-center">
          <v-chip
            v-if="item.orgon_unities.length > 0"
            color="#bce8d3"
            text-color="red"
            small
            class="ma-1"
          >
            {{ item.orgon_unities[0].unity.hospital }}
          </v-chip>
          <v-menu v-if="item.orgon_unities.length > 1" v-model="item.showMenu" offset-y>
            <template #activator="{ props }">
              <v-chip
                v-bind="props"
                color="#bce8d3"
                text-color="red"
                small
                class="ma-1 cursor-pointer"
                @click.stop="item.showMenu = !item.showMenu"
              >
                +{{ item.orgon_unities.length - 1 }}
              </v-chip>
            </template>
            <v-list dense style="max-height: 200px; overflow-y: auto; min-width: 200px;">
              <span class="ml-3">{{ $t('inputs.orgons_tissues.other_hospitals') }}</span>
              <v-list-item
                v-for="(hospital, index) in item.orgon_unities.slice(1)"
                :key="index"
              >
                <v-list-item-title>{{ hospital.unity.hospital }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="loadGridData()"
            url="orgon"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <OrgaosTecidosForm
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="dialog = false, loadGridData()"
      />
    </Modal>
  </div>
</template>

<script>
import { getOrgons } from "@/service/basic-registrations/OrgonsTissuesService";
import OrgaosTecidosForm from "./OrgonsTissues.vue";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";

export default {
  components: {
    OrgaosTecidosForm,
    Menu,
    ChangeStatus,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      loading: false,
      filterForm: {},
      filterSearch: '',
      orgons: [],
      options: {},
      headers: [
        { text: "Tipo de Orgão", align: "center", value: "type_orgon.description" },
        { text: "Descrição", align: "start", value: "name" },
        { text: "Hospitais", align: "start", value: "hospitais" },
        { text: "STATUS", align: "center", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 0,
      resource: {},
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "UsuarioForm",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.changeActionsData(this.actions);
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changeActionsData"]),

    loadGridData() {
      this.loading = true;
      getOrgons({ name: '', type_orgon: '', hospital: '' }).then((result) => {
        this.loading = false;
        this.orgons = result.map(o => ({ ...o, showMenu: false }));
      });
    },

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    applyFilter() {
      this.filterSearch = this.filterForm.name || '';
    },

    clearFilter() {
      this.filterForm = {};
      this.filterSearch = '';
    },
  },

  mounted() {
    this.loadGridData();
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
